import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import { Typography } from "@mui/material";
import { toast } from 'react-toastify';
import useEncryption from '../../../services/useEncryption';
import useHeaders from '../../../helpers/useHeaders';
import { addReviewSchema } from '../../../services/formValidator/userValidator';
import useToast from '../../../helpers/useToast';
import { addReviewApi, getAllActiveProviderApi } from '../../../api/adminApi/adminApi';

const AddReviewModal = ({ open, handleClose }) => {
  const headers = useHeaders();
  const [providers, setProviders] = useState([]);
  const toastOptions = useToast();
  const { encryptData, decryptData  } = useEncryption();

  useEffect(() => {
    if(open) {
        fetchData();
    }
}, [open]);

const fetchData = async () => {

    try {
        const response = await getAllActiveProviderApi( headers )
        const decryptedData = decryptData(response?.data?.data);
        setProviders(decryptedData);
      
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

  const formik = useFormik({
    initialValues: {
      providerId: '',
      name: '',
      rating: '',
      reviews: '',
    },
    validationSchema: addReviewSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const data = encryptData(values);
        const response = await addReviewApi(data, headers); 
        handleClose();
        resetForm();
        toast.success(response.data.message,toastOptions);
      } catch (error) {
        toast.error(error.response.data.message, toastOptions);
      }
    }
  });

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
      <div className="d-flex align-items-center justify-content-between">
        <DialogTitle id="customized-dialog-title">Add Review</DialogTitle>
        <IconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent dividers>
        <form onSubmit={formik.handleSubmit} className="sectionalForms">
          <div className="row">

            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Name"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </div>
            </div>

            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <FormControl fullWidth size="small" error={formik.touched.providerId && Boolean(formik.errors.providerId)}>
                  <InputLabel id="providerId-label">Provider</InputLabel>
                  <Select
                    labelId="providerId-label"
                    id="providerId"
                    name="providerId"
                    value={formik.values.providerId}
                    label="Provider"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {providers.map((provider) => (
                        <MenuItem key={provider?.id} value={provider?.id}>
                            {provider?.organizationName}
                        </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.providerId && formik.errors.providerId && (
                    <Typography variant="caption" color="error" style={{ marginLeft: "15px", marginTop: "4px" }}>
                      {formik.errors.providerId}
                    </Typography>
                  )}
                </FormControl>
              </div>
            </div>

            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Rating"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="rating"
                  type="number"
                  value={formik.values.rating}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.rating && Boolean(formik.errors.rating)}
                  helperText={formik.touched.rating && formik.errors.rating}
                />
              </div>
            </div>

            <div className="col-lg-12 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Review"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  multiline
                  rows={4}
                  name="reviews"
                  value={formik.values.reviews}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.reviews && Boolean(formik.errors.reviews)}
                  helperText={formik.touched.reviews && formik.errors.reviews}
                />
              </div>
            </div>

          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <div className="text-end modalactions">
          <button className="btn btn-blacked outline me-2" onClick={handleClose}>Cancel</button>
          <button className="btn btn-blacked" onClick={formik.handleSubmit}>Submit</button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default AddReviewModal;